import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';

import MenuPopover from './MenuPopover.js'

const marks = [
  {
    value: 1,
    realValue: 1,
    label: '1d',
    desription: 'Selected: one day',
  },
  {
    value: 7,
    realValue: 7,
    label: '1w',
    desription: 'Selected: one week',
  },
  {
    value: 14,
    realValue: 14,
    label: '2w',
    desription: 'Selected: two weeks',
  },
  {
    value: 28,
    realValue: 30,
    label: '1m',
    desription: 'Selected: one month',
  },
  {
    value: 35,
    realValue: 30*6,
    label: '6m',
    desription: 'Selected: six months',
  },  
  {
    value: 40,
    realValue: 365,
    label: '1y',
    desription: 'Selected: one year',
  },
];

const value_to_obj = (value) => {
  for(var i=0; i<marks.length ; i++){
    if(marks[i].value === value) {
      return marks[i];
    }
  }
}

const real_value_to_obj = (value) => {
  for(var i=0; i<marks.length ; i++){
    if(marks[i].realValue === value) {
      return marks[i];
    }
  }
}

export default function TimeGranularity(props) {
  return (
    <MenuPopover changed={props.changed} title="Time granularity">
      <Box sx={{ margin: 4, width: 250 }}>
        <Typography component="div" sx={{ flexGrow: 1 }}> {real_value_to_obj(props.value).desription} </Typography>
        <Slider
          onChangeCommitted={(_, newValue) => {
            props.valueChanged(value_to_obj(newValue).realValue);
          }}
          aria-label="Granularity"
          value={real_value_to_obj(props.value).value}
          step={null}
          min={1}
          max={40}
          valueLabelDisplay="off"
          marks={marks}
        />
      </Box>
    </MenuPopover>
  )
}

TimeGranularity.propTypes = {
  changed: PropTypes.bool,
  value: PropTypes.number,
  valueChanged: PropTypes.func,
};
